import React from 'react';
import MaskedInput from 'react-text-mask';

const TextMaskCustomPlaca = React.forwardRef((props, ref) => {
  // eslint-disable-next-line react/prop-types
  const { inputRef, ...other } = props;

  const setRef = (maskedInputEl) => {
    if (typeof inputRef === 'function') {
      inputRef(maskedInputEl ? maskedInputEl.inputElement : null);
    }

    if (ref) {
      ref(maskedInputEl ? maskedInputEl.inputElement : null);
    }
  };

  const maskFunction = (rawValue) => {
    if (rawValue.length === 7) {
      return [
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
      ];
    }
    if (rawValue.length > 7 && rawValue[7] === '-') {
      return [
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        '-',
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
        /[A-Za-z0-9]/,
      ];
    }
    return [
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
    ];
  };

  return (
    <MaskedInput
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      ref={setRef}
      mask={maskFunction}
      placeholderChar={'\u2000'}
      showMask={!!other.value}
    />
  );
});

export default TextMaskCustomPlaca;
